export default __webpack_public_path__ + "static/media/4.c1315024.jpg";